
export interface RecalculateValuationState {
  isLoading: boolean | null;
}
export const initialState = {
  isLoading: null
};
